import { render } from "./UtilitiesTrend.vue?vue&type=template&id=cb34b8ac&scoped=true"
import script from "./UtilitiesTrend.vue?vue&type=script&lang=js"
export * from "./UtilitiesTrend.vue?vue&type=script&lang=js"

import "./UtilitiesTrend.vue?vue&type=style&index=0&id=cb34b8ac&scoped=true&lang=css"
import "./UtilitiesTrend.vue?vue&type=style&index=1&id=cb34b8ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb34b8ac"]])

export default __exports__